import { useQuery } from "@tanstack/react-query";
import { partnerOffersRepo } from "@/data/repos/partnerOffersRepo";
import type { PartnerOffer } from "@/domain/offer/types";
import { partnerOffersQueryKey } from "./useReservationAnswers";

/** The same key the slevy screen fills, so arriving from a sleva row costs no
 *  second request — and nothing is asked for at all when no filter is on. */
export function useOfferById(offerId: number | null): PartnerOffer | undefined {
  const offers = useQuery({
    queryKey: partnerOffersQueryKey,
    queryFn: () => partnerOffersRepo.list(),
    enabled: offerId !== null,
  });
  return offers.data?.find((offer) => offer.id === offerId);
}
